var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
  }
  return t;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  return t;
};
import * as React from 'react';
var keyChangedKey = function (props, values, shallow) {
  var keys = Object.keys(props);
  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    if (props[key] !== values[key]) {
      if (shallow && typeof props[key] === 'object') {
        if (keyChangedKey(props[key], values[key], false)) {
          return key;
        }
      } else {
        return key;
      }
    }
  }
  return null;
};
var LatestSource = function (_super) {
  __extends(LatestSource, _super);
  function LatestSource() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = _this.initState();
    return _this;
  }
  LatestSource.getDerivedStateFromProps = function (props, state) {
    var values = props.input;
    var key = keyChangedKey(values, state.values, !!props.shallowEqual);
    if (key) {
      return {
        values: values,
        value: !props.filter || props.filter(values[key]) ? values[key] : state.value,
        activeKey: key
      };
    }
    return null;
  };
  LatestSource.prototype.initState = function () {
    var _a = this.props,
      input = _a.input,
      filter = _a.filter;
    var values = input;
    var keys = Object.keys(values);
    var activeKey = keys[0];
    if (filter) {
      for (var i = 0; i < keys.length; i++) {
        if (filter(values[keys[i]])) {
          activeKey = keys[i];
          break;
        }
      }
    }
    return {
      activeKey: activeKey,
      values: values,
      value: values[activeKey]
    };
  };
  LatestSource.prototype.render = function () {
    var _a = this.state,
      value = _a.value,
      values = _a.values,
      activeKey = _a.activeKey;
    return this.props.children(value, values[activeKey], activeKey);
  };
  return LatestSource;
}(React.Component);
export { LatestSource };
var GhostValue = function (_super) {
  __extends(GhostValue, _super);
  function GhostValue() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  GhostValue.prototype.render = function () {
    var _a = this.props,
      input = _a.input,
      props = __rest(_a, ["input"]);
    return React.createElement(LatestSource, __assign({
      input: {
        0: input
      }
    }, props));
  };
  return GhostValue;
}(React.Component);
export { GhostValue };